import setAuthToken from './setAuthToken';
import getNewAuthToken from './getNewAuthToken';
import { decodeTokenExpiry, isTokenExpiredOrExpiring } from './index';
import store from '../store';
import { LOAD_Fullfillment_TOKEN } from '../actions/type';

export const TOKEN_KEY = 'fulfil_token';

class TokenManager {
	static instance;
	accessToken = null;
	tokenExpiry = 0; // timestamp in ms
	refreshPromise = null;

	constructor() {
		this.loadTokenFromStorage();
	}

	static getInstance() {
		if (!TokenManager.instance) {
			TokenManager.instance = new TokenManager();
		}
		return TokenManager.instance;
	}

	loadTokenFromStorage() {
		const token = localStorage.getItem(TOKEN_KEY);
		if (token) {
			this.accessToken = token;
			this.tokenExpiry = decodeTokenExpiry(token);
		}
	}

	saveTokenToStorage() {
		if (this.accessToken) {
			localStorage.setItem(TOKEN_KEY, this.accessToken);
		} else {
			localStorage.removeItem(TOKEN_KEY);
		}
	}

	async fetchNewToken() {
		try {
			const token = await getNewAuthToken();
			if (!token) throw new Error('No access token returned');

			this.accessToken = token;
			this.tokenExpiry =
				decodeTokenExpiry(token) || Date.now() + 5 * 60 * 1000;
			  store.dispatch({ type: LOAD_Fullfillment_TOKEN, payload: token });
			this.saveTokenToStorage();
			setAuthToken(token, true);
			return token;
		} catch (err) {
			this.clearToken();
			throw err;
		}
	}

	async getValidToken() {
		if (!this.accessToken || isTokenExpiredOrExpiring(this.accessToken)) {
			if (!this.refreshPromise) {
				this.refreshPromise = this.fetchNewToken();
			}
			try {
				const token = await this.refreshPromise;
				return token;
			} finally {
				this.refreshPromise = null;
			}
		}
		return this.accessToken;
	}

	getToken() {
		return this.accessToken;
	}

	clearToken() {
		this.accessToken = null;
		this.tokenExpiry = 0;
		this.saveTokenToStorage();
		setAuthToken('', true);
	}
}

export default TokenManager;
